import { Button, Col, Form, Input, Row, Select, Tooltip } from 'antd';
import React from 'react';
import { type Dispatch } from 'redux';

import {
  metaDescriptionLive,
  metaKeywordsLive,
  productAIGenerateMeta,
  productAIGenerateMetaAllLanguages,
} from '../../reducers/product/reducer';
import { SPACING } from '../../theme/tokens';

export default function LanguageMetaSection({
  languageTypeCode,
  productUUID,
  inProcess,
  dispatch,
}: {
  languageTypeCode: string | undefined;
  productUUID: string;
  inProcess: boolean;
  dispatch: Dispatch;
}): React.ReactElement {
  return (
    <>
      <Row>
        <Col xs={24} sm={12}>
          <Form.Item name="metaDescription" label="Meta description">
            <Input.TextArea
              rows={3}
              placeholder="Meta description"
              onBlur={(e): void => {
                if (!languageTypeCode) return;
                dispatch(
                  metaDescriptionLive(e.target.value.trim(), languageTypeCode),
                );
              }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col xs={24} sm={12}>
          <Form.Item name="metaKeywords" label="Meta keywords">
            <Select
              mode="tags"
              tokenSeparators={[',']}
              placeholder="Add keyword and press Enter or comma"
              onChange={(value: string[]): void => {
                if (!languageTypeCode) return;
                dispatch(metaKeywordsLive(value, languageTypeCode));
              }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={SPACING.sm}>
        <Col>
          <Tooltip title="Generate meta description and keywords using AI (SEO-optimised, language-aware)">
            <Button
              size="small"
              disabled={inProcess || !productUUID || !languageTypeCode}
              onClick={(): void => {
                if (!languageTypeCode || !productUUID) return;
                dispatch(productAIGenerateMeta(productUUID, languageTypeCode));
              }}
            >
              Generate meta (AI)
            </Button>
          </Tooltip>
        </Col>
        <Col>
          <Tooltip title="Generate meta description and keywords for all active languages using AI">
            <Button
              size="small"
              disabled={inProcess || !productUUID || !languageTypeCode}
              onClick={(): void => {
                if (!languageTypeCode || !productUUID) return;
                dispatch(
                  productAIGenerateMetaAllLanguages(
                    productUUID,
                    languageTypeCode,
                  ),
                );
              }}
            >
              Generate meta – all languages (AI)
            </Button>
          </Tooltip>
        </Col>
      </Row>
    </>
  );
}
